export enum ExternalUrlFormIds {
  urlTemplate = 'urlTemplate',
  longDescription = 'longDescription',
  disabled = 'disabled',
  language = 'language',
  sequence = 'sequence',
  caseType = 'caseType',
  operation = 'operation'
}

export const languageValidationParameter = 'description';
export const longDescriptionValidationParameter = 'longDescription';
export const maxDescriptionLength = 254;

export enum ExternalUrlDragItemType {
  externalUrlTile = 'EXTERNAL_URL_TILE'
}
